import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExpand } from '@fortawesome/free-solid-svg-icons';

interface NavigationTabsProps {
    scrollToPlanimetry: () => void;
    planimetryTabText: string;
}

export const NavigationTabs: React.FC<NavigationTabsProps> = ({
    scrollToPlanimetry,
    planimetryTabText
}) => (
    <ul className='nav nav-tabs nav-tabs-02 mb-4 nav-on-photos d-none'>
        <li className="nav-item mb-2">
            <a 
                className="nav-link shadow smooth-scrolling" 
                href="#planimetrie" 
                title={planimetryTabText}
                onClick={(e) => {
                    e.preventDefault();
                    scrollToPlanimetry();
                }}
                role="tab"
            >
                <FontAwesomeIcon icon={faExpand} className="mr-2" />
                {planimetryTabText}
            </a>
        </li>
    </ul>
);